import { DISPLAY_CURRENCIES } from "common/constants";
import ChangeTag from "common/Tags/ChangeTag";
import React, { CSSProperties } from "react";
import { useSelector } from "react-redux";
import { useTheme } from "styled-components";
import { selectDisplayCurrency } from "@shared/slices/common.slice";
import { BasicBotData, BotData } from "@shared/types";
import { getDisplayCurrencyPrecision } from "@shared/features/onboarding/utils";

interface BotChangeProps {
  botData?: BotData | BasicBotData;
  isRealizedPnl?: boolean;
  style?: CSSProperties;
  isOpenTrades?: boolean;
}

const BotChange = ({
  botData,
  isRealizedPnl,
  isOpenTrades,
  style,
}: BotChangeProps) => {
  const displayCurrency = useSelector(selectDisplayCurrency);
  const { isNewLook } = useTheme();

  const getChange = () => {
    if (isRealizedPnl) {
      return botData?.realised_pnl?.[displayCurrency] || 0;
    }
    const changeIndex = displayCurrency === DISPLAY_CURRENCIES.USD ? 0 : 1;
    const changeObject = isOpenTrades
      ? botData?.open_trades_change
      : botData?.change;
    return changeObject?.[changeIndex] || 0;
  };

  const change = getChange();

  if (isNewLook) {
    // New look: PnL is signed text in colour only (+$7.9 / −$4.1), no chip.
    // ChangeTag writes the sign itself in the new look.
    return (
      <ChangeTag
        value={change}
        hideBackground={true}
        colorZeroValue={false}
        precision={getDisplayCurrencyPrecision(displayCurrency)}
        showArrow={false}
        style={{ marginLeft: 0, fontSize: "inherit", ...style }}
        textStyle={NEW_LOOK_TEXT_STYLE}
      />
    );
  }

  return (
    <ChangeTag
      value={change}
      precision={getDisplayCurrencyPrecision(displayCurrency)}
      showArrow={false}
      style={style}
    />
  );
};

export default React.memo(BotChange);

// Inherit the surrounding figure size instead of ChangeTag's chip size.
const NEW_LOOK_TEXT_STYLE: CSSProperties = {
  fontSize: "inherit",
  fontVariantNumeric: "tabular-nums",
  whiteSpace: "nowrap",
};
